import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantDifferentResidenceTypePage = {
  alert: {
    error: 'coapplicant-different-residence-type-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-different-residence-type-page.footer.root',
  },
  form: {
    h1: 'coapplicant-different-residence-type-page.form.h1',
    h2: 'coapplicant-different-residence-type-page.form.h2',
    radioGroupRoot:
      'coapplicant-different-residence-type-page.form.radio-group-root',
    radioOption1:
      'coapplicant-different-residence-type-page.form.radio-option1',
    radioOption2:
      'coapplicant-different-residence-type-page.form.radio-option2',
    radioOption3:
      'coapplicant-different-residence-type-page.form.radio-option3',
    root: 'coapplicant-different-residence-type-page.form.root',
    submitButton:
      'coapplicant-different-residence-type-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
